import { BrowserRouter, Routes, Route } from "react-router-dom";

import HomePage from "../frontend/homepage";
import InscriptionEntreprise from "../frontend/inscriptions/inscriptionEntreprise";
import InscriptionParticulier from "../frontend/inscriptions/inscriptionParticulier";
import Login from "../backend/auth/login";
import Register from "../backend/auth/register";
import Dashboard from "../backend/dashboard";
import IndexPublications from "../backend/publications";
import CreatePublications from "../backend/publications/create";
import EditPublications from "../backend/publications/edit";
import ShowPublications from "../backend/publications/show";
import Abonnements from "../backend/ventes/abonnements";
import Ventes from "../backend/ventes/ventes";
import IndexRoles from "../backend/roles";
import CreateRoles from "../backend/roles/create";
import EditRoles from "../backend/roles/edit";
import CreateStatuts from "../backend/statuts/create";
import EditStatuts from "../backend/statuts/edit";
import IndexStatuts from "../backend/statuts";
import IndexUsers from "../backend/users";
import CreateUsers from "../backend/users/create";
import EditUsers from "../backend/users/edit";
import ShowUsers from "../backend/users/show";
import Catalogue from "../frontend/catalogue";
import Contact from "../frontend/contact";
import CommentCaMarche from "../frontend/comment_ca_marche";
import DetailsPublications from "../frontend/details_publications";
//import { Suspense } from "react";
import IndexCategories from "../backend/categories";
import CreateCategories from "../backend/categories/create";
import EditCategories from "../backend/categories/edit";
import IndexCollections from "../backend/collections";
import CreateCollections from "../backend/collections/create";
import EditCollections from "../backend/collections/edit";
import IndexRubriques from "../backend/rubriques";
import CreateRubriques from "../backend/rubriques/create";
import EditRubriques from "../backend/rubriques/edit";
import IndexModePaiements from "../backend/modepaiements";
import CreateModePaiements from "../backend/modepaiements/create";
import EditModePaiements from "../backend/modepaiements/edit";
import Monpanier from "../frontend/monpanier";
import IndexPeriodicites from "../backend/periodicites";
import CreatePeriodicites from "../backend/periodicites/create";
import EditPeriodicites from "../backend/periodicites/edit";
import IndexFrequenceParutions from "../backend/frequenceparutions";
import CreateFrequenceParutions from "../backend/frequenceparutions/create";
import EditFrequenceParutions from "../backend/frequenceparutions/edit";
import IndexEditeurs from "../backend/editeurs";
import CreateEditeurs from "../backend/editeurs/create";
import EditEditeurs from "../backend/editeurs/edit";
import IndexAuteurs from "../backend/auteurs";
import CreateAuteurs from "../backend/auteurs/create";
import EditAuteurs from "../backend/auteurs/edit";
import ShowAuteurs from "../backend/auteurs/show";
import IndexPeriodiques from "../backend/periodiques";
import CreatePeriodiques from "../backend/periodiques/create";
import EditPeriodiques from "../backend/periodiques/edit";
//import ShowPeriodiques from "../backend/periodiques/show";
import IndexMotsCles from "../backend/motscles";
import CreateMotsCles from "../backend/motscles/create";
import EditMotsCles from "../backend/motscles/edit";
import IndexTypes from "../backend/types";
import CreateTypes from "../backend/types/create";
import EditTypes from "../backend/types/edit";
import CreateTypesPublications from "../backend/typespublications/create";
import IndexTypesPublications from "../backend/typespublications";
import EditTypesPublications from "../backend/typespublications/edit";
import IndexContacts from "../backend/contacts";
import ListeReversements from "../backend/reversements";
import ReversementPage from "../backend/reversements/create";
import Commander from "../frontend/commande/commander";
import Paiement from "../frontend/commande/paiement";
import Confirmation from "../frontend/commande/confirmation_paiement";
import ForgotPassword from "../backend/auth/forgotPassword";
import NewPassword from "../backend/auth/newPassword";
import ProfilUser from "../backend/users/profil";
import ProfilEdit from "../backend/users/edit_profil";
import Moncompte from "../frontend/moncompte/moncompte";
import EditTarifications from "../backend/tarifications/edit";
import CreateTarifications from "../backend/tarifications/create";
import IndexTarifications from "../backend/tarifications";
import Consultation from "../frontend/commande/consultation";
import Recherche from "../frontend/recherche";

//
//const Login = lazy(() => import('../backend/auth/login'));

//Déclaration des noms des routes

const myroutes = {

    homepage: "/",
    login: "/login",
    register: "/store/inscrit",
    register_entreprise: "/store/inscrit/entreprise",
    forgot_password: "/user/passwordchange",
    new_password: "/user/newpassword/:token",

    ///############## BACK OFFICE PATH ######################///

    dashboard: "/admin/dashboard",
    //Publications
    publications_index: "/admin/publications/index",
    publications_create: "/admin/publications/create",
    publications_edit: "/admin/publications/edit",
    publications_show: "/admin/publications/show",
    //Ventes
    ventes: "/admin/ventes/quotidiennes",
    abonnements: "/admin/ventes/abonnements",
    //Roles
    roles_index: "/admin/roles",
    roles_create: "/admin/roles/create",
    roles_edit: "/admin/roles/edit",
    //Statuts
    statuts_index: "/admin/statuts",
    statuts_create: "/admin/statuts/create",
    statuts_edit: "/admin/statuts/edit",
    //Utilisateurs
    users_index: "/admin/users",
    users_create: "/admin/users/create",
    users_edit: "/admin/users/edit",
    users_show: "/admin/users/show",
    profil_user: "/admin/users/profil",
    profil_edit: "/admin/users/profil/edit",

    //Categories
    categories_index: "/admin/categories",
    categories_create: "/admin/categories/create",
    categories_edit: "/admin/categories/edit",
    //Collections
    collections_index: "/admin/collections",
    collections_create: "/admin/collections/create",
    collections_edit: "/admin/collections/edit",
    //Rubriques
    rubriques_index: "/admin/rubriques",
    rubriques_create: "/admin/rubriques/create",
    rubriques_edit: "/admin/rubriques/edit",
    //Mode paiements
    modepaiements_index: "/admin/modepaiements",
    modepaiements_create: "/admin/modepaiements/create",
    modepaiements_edit: "/admin/modepaiements/edit",
    //Frequence parutions
    frequenceparutions_index: "/admin/frequenceparutions",
    frequenceparutions_create: "/admin/frequenceparutions/create",
    frequenceparutions_edit: "/admin/frequenceparutions/edit",
    //Periodicites
    periodicites_index: "/admin/periodicites",
    periodicites_create: "/admin/periodicites/create",
    periodicites_edit: "/admin/periodicites/edit",
    //Auteurs
    auteurs_index: "/admin/auteurs",
    auteurs_create: "/admin/auteurs/create",
    auteurs_edit: "/admin/auteurs/edit",
    auteurs_show: "/admin/auteurs/show",
    //Editeurs
    editeurs_index: "/admin/editeurs",
    editeurs_create: "/admin/editeurs/create",
    editeurs_edit: "/admin/editeurs/edit",

    //Periodiques
    periodiques_index: "/admin/periodiques",
    periodiques_create: "/admin/periodiques/create",
    periodiques_edit: "/admin/periodiques/edit",
    //periodiques_show: "/admin/periodiques/show",

    //Mots cles
    motscles_index: "/admin/motscles",
    motscles_create: "/admin/motscles/create",
    motscles_edit: "/admin/motscles/edit",

    //Types
    types_index: "/admin/types",
    types_create: "/admin/types/create",
    types_edit: "/admin/types/edit",
    //Types publications
    typespublications_index: "/admin/typespublications",
    typespublications_create: "/admin/typespublications/create",
    typespublications_edit: "/admin/typespublications/edit",

    //Contacts
    contact_liste: "/admin/contacts/liste",
    //Reversements
    liste_reversements: "/admin/ventes/reversements/liste",
    reversements_page: "/admin/ventes/reversements/operation",

    //Tarifications
    tarifications_index: "/admin/tarifications",
    tarifications_create: "/admin/tarifications/create",
    tarifications_edit: "/admin/tarifications/edit",
    tarifications_show: "/admin/tarifications/show",

    ///############## BACK OFFICE PATH ######################///

    //name des routes pour l'inscription

    inscription_particulier: "/inscriptions/particulier",
    inscription_entreprise: "/inscriptions/entreprise",

    //name route catalogue

    catalogue: "/catalogue",

    //name route contact

    contact: "/contact",

    //name route comment ca marche

    comment_ca_marche: "/comment_ca_marche",

    //name route details publications

    details_publications: "/details_publications/:id",

    //name route filter publications

    publications_categories: "/publications-categories/:categories",
     //name route panier

     monpanier: "/monpanier",

     //route pour la page de commande
     commandes: "/commandes",

     //route pour la page de commande
     paiement: "/paiement",

      //route pour la page de commande
      confirmation: "/confirmation",

      //route pour la page de commande
      moncompte: "/moncompte",

      //route pour la page de consulation
      consultation: "/consulation",

        //name route recherche_par_titre

        recherche_par_titre: "/publications/recherche_par_titre/:searchTerm",

     
}

export { myroutes };

export default function Webroute() {
    return (
        <BrowserRouter>
            {/*<Suspense fallback={<div className="container">En cours...</div>}>*/}
                <Routes>

                    {/** Route de la page d'accueil principale */}
                    <Route path={myroutes.homepage} name="homepage" element={<HomePage />} />

                    <Route path={myroutes.login} name="login" element={<Login />} />
                    <Route path={myroutes.register} name="register" element={<InscriptionParticulier />} />
                    <Route path={myroutes.register_entreprise} name="register_entreprise" element={<InscriptionEntreprise />} />
                    <Route path={myroutes.forgot_password} element={<ForgotPassword />} />
                    <Route path={myroutes.new_password} element={<NewPassword />} />

                    {/** Routes de inscriptions */}

                    <Route path={myroutes.inscription_particulier} name="inscription_particulier" element={<InscriptionParticulier />} />
                    <Route path={myroutes.inscription_entreprise} name="inscription_entreprise" element={<InscriptionEntreprise />} />

                    {/** Route catalogue */}

                    <Route path={myroutes.catalogue} name="catalogue" element={<Catalogue />} />

                    {/** Route contact */}

                    <Route path={myroutes.contact} name="contact" element={<Contact />} />

                    {/** Route comment_ca_marche */}

                    <Route path={myroutes.comment_ca_marche} name="comment_ca_marche" element={<CommentCaMarche />} />

                     {/** Route consultation */}

                     <Route path={myroutes.consultation} name="consultation" element={<Consultation />} />

                    {/** Route recherche par titre */}

                    <Route path={myroutes.recherche_par_titre} name="recherche_par_titre" element={<Recherche />} />

                    {/** Route details_publications*/}

                    <Route path={myroutes.details_publications} name="/details_publications/:id" element={<DetailsPublications />} />

                    <Route path={myroutes.publications_categories} name="/publications-categories/:categories" element={<Catalogue />} />


                    {/** Route vers le panier*/}

                    <Route path={myroutes.monpanier} name="/monpanier" element={<Monpanier/>} />

                     {/** Route vers la page de commande*/}

                     <Route path={myroutes.commandes} name="/commandes" element={<Commander/>} />

                     {/** Route vers la page de paiement*/}

                     <Route path={myroutes.paiement} name="/paiement" element={<Paiement/>} />

                     {/** Route vers la page de confirmation paiement*/}

                     <Route path={myroutes.confirmation} name="/confirmation" element={<Confirmation/>} />

                      {/** Route vers la page de consultation de compte*/}

                      <Route path={myroutes.moncompte} name="/moncompte" element={<Moncompte/>} />



                    {/** Start Route BACK OFFICE */}
                    <Route path={myroutes.dashboard} name="dashboard" element={<Dashboard />} />
                    {/** Publications */}
                    <Route path={myroutes.publications_index} name="publications_index" element={<IndexPublications />} />
                    <Route path={myroutes.publications_create} name="publications_create" element={<CreatePublications />} />
                    <Route path={myroutes.publications_edit} name="publications_edit" element={<EditPublications />} />
                    <Route path={myroutes.publications_show} name="publications_show" element={<ShowPublications />} />
                    {/** Ventes */}
                    <Route path={myroutes.abonnements} name="abonnements" element={<Abonnements />} />
                    <Route path={myroutes.ventes} name="ventes" element={<Ventes />} />
                    {/** Roles */}
                    <Route path={myroutes.roles_index} name="Roles index" element={<IndexRoles />} />
                    <Route path={myroutes.roles_create} name="roles_create" element={<CreateRoles />} />
                    <Route path={myroutes.roles_edit} name="roles_edit" element={<EditRoles />} />
                    {/** Statuts */}
                    <Route path={myroutes.statuts_index} name="Statuts index" element={<IndexStatuts />} />
                    <Route path={myroutes.statuts_create} name="statuts_create" element={<CreateStatuts />} />
                    <Route path={myroutes.statuts_edit} name="statuts_edit" element={<EditStatuts />} />
                    {/** Users */}
                    <Route path={myroutes.users_index} name="Users index" element={<IndexUsers />} />
                    <Route path={myroutes.users_create} name="Users create" element={<CreateUsers />} />
                    <Route path={myroutes.users_edit} name="Users edit" element={<EditUsers />} />
                    <Route path={myroutes.users_show} name="Users show" element={<ShowUsers />} />
                    <Route path={myroutes.profil_user} name="Users Profil" element={<ProfilUser />} />
                    <Route path={myroutes.profil_edit} name="Users Profil Edit" element={<ProfilEdit />} />

                    {/** Categories */}
                    <Route path={myroutes.categories_index} element={<IndexCategories />} />
                    <Route path={myroutes.categories_create} element={<CreateCategories />} />
                    <Route path={myroutes.categories_edit} element={<EditCategories />} />

                    {/** Collections */}
                    <Route path={myroutes.collections_index} element={<IndexCollections />} />
                    <Route path={myroutes.collections_create} element={<CreateCollections />} />
                    <Route path={myroutes.collections_edit} element={<EditCollections />} />

                    {/** Rubriques */}
                    <Route path={myroutes.rubriques_index} element={<IndexRubriques />} />
                    <Route path={myroutes.rubriques_create} element={<CreateRubriques />} />
                    <Route path={myroutes.rubriques_edit} element={<EditRubriques />} />
                    {/** Mode paiements */}
                    <Route path={myroutes.modepaiements_index} element={<IndexModePaiements />} />
                    <Route path={myroutes.modepaiements_create} element={<CreateModePaiements />} />
                    <Route path={myroutes.modepaiements_edit} element={<EditModePaiements />} />

                    {/** Periodicites */}
                    <Route path={myroutes.periodicites_index} element={<IndexPeriodicites />} />
                    <Route path={myroutes.periodicites_create} element={<CreatePeriodicites />} />
                    <Route path={myroutes.periodicites_edit} element={<EditPeriodicites />} />
                    {/** Frequence parutions */}
                    <Route path={myroutes.frequenceparutions_index} element={<IndexFrequenceParutions />} />
                    <Route path={myroutes.frequenceparutions_create} element={<CreateFrequenceParutions />} />
                    <Route path={myroutes.frequenceparutions_edit} element={<EditFrequenceParutions />} />
                    {/** Editeurs */}
                    <Route path={myroutes.editeurs_index} element={<IndexEditeurs />} />
                    <Route path={myroutes.editeurs_create} element={<CreateEditeurs />} />
                    <Route path={myroutes.editeurs_edit} element={<EditEditeurs />} />
                    {/** Auteurs */}
                    <Route path={myroutes.auteurs_index} element={<IndexAuteurs />} />
                    <Route path={myroutes.auteurs_create} element={<CreateAuteurs />} />
                    <Route path={myroutes.auteurs_edit} element={<EditAuteurs />} />
                    <Route path={myroutes.auteurs_show} element={<ShowAuteurs />} />
                    {/** Periodiques */}
                    <Route path={myroutes.periodiques_index} element={<IndexPeriodiques />} />
                    <Route path={myroutes.periodiques_create} element={<CreatePeriodiques />} />
                    <Route path={myroutes.periodiques_edit} element={<EditPeriodiques />} />
                    {/*<Route path={myroutes.periodiques_show} element={<ShowPeriodiques />} />*/}
                    {/** Mots cles */}
                    <Route path={myroutes.motscles_index} element={<IndexMotsCles />} />
                    <Route path={myroutes.motscles_create} element={<CreateMotsCles />} />
                    <Route path={myroutes.motscles_edit} element={<EditMotsCles />} />
                    {/** Types */}
                    <Route path={myroutes.types_index} name="Types index" element={<IndexTypes />} />
                    <Route path={myroutes.types_create}  element={<CreateTypes />} />
                    <Route path={myroutes.types_edit} element={<EditTypes />} />
                    {/** Types publications*/}
                    <Route path={myroutes.typespublications_index} name="Types index" element={<IndexTypesPublications />} />
                    <Route path={myroutes.typespublications_create}  element={<CreateTypesPublications />} />
                    <Route path={myroutes.typespublications_edit} element={<EditTypesPublications />} />

                    {/** Contacts*/}
                    <Route path={myroutes.contact_liste} element={<IndexContacts />} />

                    {/** Reversements*/}
                    <Route path={myroutes.liste_reversements} element={<ListeReversements />} />
                    <Route path={myroutes.reversements_page} element={<ReversementPage />} />

                    {/** Tarifications*/}
                    <Route path={myroutes.tarifications_index} name="Tarifications" element={<IndexTarifications />} />
                    <Route path={myroutes.tarifications_create}  element={<CreateTarifications />} />
                    <Route path={myroutes.tarifications_edit} element={<EditTarifications />} />

                    {/** END Route BACK OFFICE */}

                    


                </Routes>
            {/*</Suspense>*/}
        </BrowserRouter>
    )
}